import { render, staticRenderFns } from "./IncentivosIndex.vue?vue&type=template&id=624c5370&scoped=true"
import script from "./IncentivosIndex.vue?vue&type=script&lang=js"
export * from "./IncentivosIndex.vue?vue&type=script&lang=js"
import style0 from "./IncentivosIndex.vue?vue&type=style&index=0&id=624c5370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624c5370",
  null
  
)

export default component.exports